module.exports = __webpack_public_path__ + "img/banner-kz-mobile.8a56fe1a.jpg";